import { alpha } from '@mui/material';
/**
 * Neutral colors by shade number
 */
export var neutral02 = '#fafaf9';
export var neutral05 = '#f4f4f3';
export var neutral10 = '#e7e7e6';
export var neutral20 = '#cececd';
export var neutral30 = '#b4b4b3';
export var neutral40 = '#9a9a99';
export var neutral50 = '#80807f';
export var neutral60 = '#676766';
export var neutral70 = '#4d4d4c';
export var neutral80 = '#333333';
export var neutral90 = '#191919';
/**
 * Opaque alternatives
 */
export var neutral60opacity05 = alpha(neutral60, 0.05);
export var neutral60opacity10 = alpha(neutral60, 0.1);
export var neutral60opacity15 = alpha(neutral60, 0.15);
export var neutral60opacity20 = alpha(neutral60, 0.2);
